import { render } from "./CustomerCarDialog.vue?vue&type=template&id=5bd72aff&scoped=true"
import script from "./CustomerCarDialog.vue?vue&type=script&lang=js"
export * from "./CustomerCarDialog.vue?vue&type=script&lang=js"

import "./CustomerCarDialog.vue?vue&type=style&index=0&id=5bd72aff&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd72aff"]])

export default __exports__